var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"CuratedList"},[_c('div',{staticClass:"container",class:{'hiddenPrevButton': this.activeSlider ===0 }},[(_vm.data.title)?_c('h3',[_vm._v(_vm._s(_vm.data.title))]):_vm._e(),_vm._v(" "),_c('Slick',{ref:"slick",staticClass:"carousel",attrs:{"options":{
        swipe: true,
        swipeToSlide: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: false,
        dots: true,
        arrows:true,
        prevArrow: "<button type='button' class='slick-prev prev'></button>",
        nextArrow: "<button type='button' class='slick-next next'></button>",
        pauseOnFocus: true,
        autoplay: false,
        lazyLoad: false,
        responsive: [
          {
            breakpoint: _vm.mobileDeviceScreenSize,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows:false,
            }
          } ]
      }},on:{"afterChange":_vm.handleAfterChange}},_vm._l((_vm.data.bannerList),function(item,index){return _c('div',{key:index,staticClass:"item"},[_c('a',{staticClass:"label",attrs:{"href":item.bannerLink}},[_c('imageView',{attrs:{"image":item.banner,"desiredSize":_vm.getImageSize}})],1)])}),0)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-067789d0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/partials/CuratedList/CuratedList.vue
// module id = null
// module chunks = 